import Appsignal from '@appsignal/javascript';

const appSignal = new Appsignal({
  key: process.env.APPSIGNAL_FE_KEY,
  revision: process.env.APP_REVISION,
});

export default appSignal;
